import UserAvatar from 'components/pure/utils/UserAvatar';
import React from 'react';
import {Link} from 'react-router';
import './ProfileAndName.styl';
import buildUrl from 'components/dashboard/buildUrl';
import {HISTORY_ACTIONS} from 'components/StatsPage2.utils';

export const RepProfileAndName = ({
  rep,
  coachId,
  manager,
  // XXX only managerId is needed, but ripping out manager and replace with managerId is more work than I want atm
  managerId,
  adminId,
  includeName = true,
  includeAvatar = true,
  fromPath = null,
  tooltipEnabled = true,
}) => {
  // params from dashv2 that are needed for the v1 rep stats page
  const state = fromPath
    ? {
        pathname: fromPath,
        action: HISTORY_ACTIONS.PUSH,
      }
    : {};
  const disabled = rep.active ? '' : 'disabled';
  const avatarAndName = (
    <div className={`coaching-profile-container ${disabled}`}>
      {includeAvatar && (
        <UserAvatar user={rep} enableTooltip={tooltipEnabled} tooltipDirection="top" />
      )}
      {includeName && <span className="linked">{rep.getDisplayName()}</span>}
    </div>
  );
  if (!rep.active) {
    return avatarAndName;
  }
  // If the rep is a coach and we are not on a coach's page already, then open the rep as a coach.
  // But, if we are not on admin's pages, then the rep's manager must match the authUser (otherwise we will get a 403)
  if (rep.is_coach && !coachId && (adminId || managerId === rep.managerId)) {
    const link = buildUrl({
      adminId,
      managerId: managerId ? managerId : manager ? manager.id : null,
      coachId: rep.id,
    });
    return (
      <Link to={{pathname: link, state}} className="generic-link">
        {avatarAndName}
      </Link>
    );
  } else {
    return (
      <Link
        to={{
          pathname: `/metrics/profile`,
          query: {
            managerId: rep.managerId,
            userId: rep.id,
            teamId: rep.teamId,
          },
          state,
        }}
        className="generic-link">
        {avatarAndName}
      </Link>
    );
  }
};

export const ManagerProfileAndNameLink = ({
  mgr, // this is the manager that this link represents
  disabled = false,
  adminId = null,
  manager = null, // this is the manager of the current dashv2 page, if any
}) => {
  // no link if disabled. no link if it would take us to where we already are.
  const makeLink = disabled || (manager && manager.id === mgr.id);
  const link = makeLink
    ? null
    : buildUrl({
        managerId: mgr.id,
        adminId,
      }) + '/coaching-plans';

  const userAndAvatar = (
    <div className="coaching-profile-container">
      <UserAvatar user={mgr} enableTooltip={true} tooltipDirection="top" />
    </div>
  );

  const linkOrAvatar = link ? (
    <Link to={link} className="generic-link">
      {userAndAvatar}
    </Link>
  ) : (
    userAndAvatar
  );

  return <div className="avatar-wrapper">{linkOrAvatar}</div>;
};
